import {
  ActionIcon,
  Box,
  Button,
  Grid,
  Group,
  Input,
  LoadingOverlay,
  Modal,
  Tooltip,
} from "@mantine/core";
import {
  IconEdit,
  IconEye,
  IconPlus,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import { renderAsync } from "docx-preview";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useRef, useState } from "react";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";

import { useNavigate } from "react-router-dom";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { api } from "../../../library/axios";
import { MessageResponse } from "../../../model/MessageResponse";
import { CongVanModel } from "../../../model/ModelCongVan";
import { useForm } from "@mantine/form";

const Congvanlist = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedBase64, setSelectedBase64] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDocxLoading, setIsDocxLoading] = useState(false);
  const docxContainerRef = useRef<HTMLDivElement>(null);

  const handleViewFile = async (row: any) => {
    if (!row.tepDinhKem) {
      NotificationExtension.Fails("Không có file đính kèm!");
      return;
    }

    setSelectedRow(row);
    setSelectedBase64(row.tepDinhKem.trim());
    setSelectedFileName("Congvan.docx");
    setIsModalOpen(true);
  };

  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const form = useForm<any>({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: "",
    },
  });
  useEffect(() => {
    const renderDocx = async () => {
      if (!selectedRow || !isModalOpen) return;

      await new Promise((resolve) => setTimeout(resolve, 100));

      if (!docxContainerRef.current) {
        console.error("Container ref is null");
        return;
      }

      setIsDocxLoading(true);
      try {
        const base64 = selectedRow.tepDinhKem.trim();
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, (char) =>
          char.charCodeAt(0)
        );
        const byteArray = new Uint8Array(byteNumbers);

        if (docxContainerRef.current) {
          docxContainerRef.current.innerHTML = "";

          await renderAsync(
            byteArray.buffer,
            docxContainerRef.current,
            undefined,
            {
              className: "docx",
              inWrapper: false,
              ignoreWidth: false,
              ignoreHeight: false,
              ignoreFonts: false,
              breakPages: true,
              ignoreLastRenderedPageBreak: true,
              experimental: false,
              trimXmlDeclaration: true,
            }
          );
        }
      } catch (error) {
        console.error("Lỗi khi hiển thị file .docx:", error);
        NotificationExtension.Fails("Không thể hiển thị file .docx");

        if (docxContainerRef.current) {
          docxContainerRef.current.innerHTML = `
            <div style="text-align: center; padding: 20px; color: #f03e3e;">
              <p>Không thể hiển thị file .docx</p>
              <p>Vui lòng thử tải xuống file để xem</p>
            </div>
          `;
        }
      } finally {
        setIsDocxLoading(false);
      }
    };

    renderDocx();
  }, [isModalOpen, selectedRow]);

  const handleDownload = () => {
    if (!selectedBase64) return;

    const link = document.createElement("a");
    link.href = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${selectedBase64}`;
    link.download = selectedFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
    setSelectedBase64("");
    setSelectedFileName("");
    setIsDocxLoading(false);

    if (docxContainerRef.current) {
      docxContainerRef.current.innerHTML = "";
    }
  };

  const [data, setData] = useState<CongVanModel[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);

  const fetchData = async () => {
    setIsLoading(true);
    setIsError(false);
    let url = `?Skip=${pagination.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (form.getValues().KeySearch) {
      url += `&KeySearch=${form.getValues().KeySearch}`;
    }
    try {
      const response = await api.get<MessageResponse<CongVanModel[]>>(
        `/TblCongVan/get-list${url}`
      );
      if (response && response.data && response.data.success) {
        setData(response.data.data);
        setRowCount(response.data.totalCount);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };
  console.log("dataa", data);
  const navigate = useNavigate();

  const handleCreateNew = () => {
    navigate("/document-manager/edit-congvan-list");
  };

  const handleEdit = (id: number) => {
    navigate(`/document-manager/edit-congvan-list`, { state: { id } });
  };

  const handleDelete = async (id: number) => {
    try {
      await api.post(`/TblCongVan/delete`, [id]);
      NotificationExtension.Success("Xóa công văn thành công!");
      await fetchData();
    } catch (error) {
      console.error("Error deleting candidate:", error);
      NotificationExtension.Fails("Xóa công văn thất bại!");
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      { accessorKey: "id", header: "ID" },
      {
        accessorKey: "loaiCongVan",
        header: "Loại Công Văn",
        Cell: ({ cell }) =>
          cell.getValue() === "đến" ? "Công văn đến" : "Công văn đi",
      },
      { accessorKey: "donVi", header: "Đơn Vị" },
      { accessorKey: "soVanBan", header: "Số Văn Bản" },
      { accessorKey: "soDen", header: "Số Đến" },
      { accessorKey: "soDi", header: "Số Đi" },
      {
        accessorKey: "ngayDen",
        header: "Ngày Đến",
      },
      {
        accessorKey: "ngayPhatHanh",
        header: "Ngày Phát Hành",
      },
      { accessorKey: "soBanPhatHanh", header: "Số Bản PH" },
      {
        accessorKey: "ngayCoHieuLuc",
        header: "Hiệu Lực Từ",
      },
      {
        accessorKey: "ngayHetHieuLuc",
        header: "Hiệu Lực Đến",
      },
      { accessorKey: "noiGui", header: "Nơi Gửi" },
      { accessorKey: "noiNhan", header: "Nơi Nhận" },
      { accessorKey: "nguoiKy", header: "Người Ký" },
      { accessorKey: "loaiVanBan", header: "Loại Văn Bản" },
      { accessorKey: "mucDoKhanCap", header: "Khẩn Cấp" },
      { accessorKey: "mucDoBaoMat", header: "Bảo Mật" },
      { accessorKey: "soTrang", header: "Số Trang" },
      { accessorKey: "dangVanBan", header: "Dạng Văn Bản" },
      { accessorKey: "viTriLuuTru", header: "Vị Trí Lưu Trữ" },
      { accessorKey: "tepDinhKem", header: "Tệp Đính Kèm" },
      { accessorKey: "trichYeuNoiDung", header: "Trích Yếu" },
      { accessorKey: "nguoiXuLy", header: "Người Xử Lý" },
      { accessorKey: "tinhTrangXuLy", header: "Tình Trạng Xử Lý" },
      {
        accessorKey: "hanXuLy",
        header: "Hạn Xử Lý",
        Cell: ({ cell }) =>
          formatDateNotTimeZone(
            cell.getValue() as string | Date | null | undefined
          ),
      },
      {
        accessorKey: "choPhepTraCuu",
        header: "Tra Cứu",
        Cell: ({ cell }) => (cell.getValue() ? "✔️" : "❌"),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 140,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                color="cyan"
                onClick={() => handleViewFile(row.original)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="yellow"
                onClick={() => handleEdit(row.original.id)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={() => handleDelete(row.original.id)}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    rowCount,
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
    },
    localization: _localization,
    manualPagination: true,
    onPaginationChange: setPagination,
    paginationDisplayMode: "pages",
    enableColumnResizing: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    initialState: {
      columnPinning: {
        left: [""],
        right: ["action"],
      },
    },
    mantineTableBodyCellProps: ({}) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },

    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  return (
    <Box>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Group justify="space-between">
          <_breadcrumb></_breadcrumb>
        </Group>

        <Box
          mt={10}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid>
            <Grid.Col
              style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
            >
              <Input
                placeholder="Tìm kiếm"
                leftSection={<IconSearch size={20} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") await fetchData();
                }}
                {...form.getInputProps("KeySearch")}
              />

              <Button
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>

          <Button
            mr={10}
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={handleCreateNew}
          >
            Thêm mới
          </Button>
        </Box>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
        <Modal
          opened={isModalOpen}
          onClose={handleCloseModal}
          title="Xem nội dung Công văn"
          size="full"
          styles={{
            body: {
              maxHeight: "90vh",
              // overflowY: "auto",
              position: "relative",
            },
          }}
        >
          <LoadingOverlay visible={isDocxLoading} />
          <div
            ref={docxContainerRef}
            style={{
              width: "70%",
              minHeight: "200px",

              padding: "10px",
              backgroundColor: "#fff",
            }}
          />
          <Button
            mt="md"
            fullWidth
            color="blue"
            onClick={handleDownload}
            disabled={!selectedBase64}
          >
            Tải xuống Công văn ({selectedFileName})
          </Button>
        </Modal>
      </Box>
    </Box>
  );
};

export default Congvanlist;
